import React from "react";
import BaseSpread, { CardPosition } from "./BaseSpread";

// Generate position data for Tree of Life spread (10 cards)
// Cards are arranged in the traditional Tree of Life formation:
// Top row: Card 10 (center)
// Second row: Cards 2 and 1 (left and right)
// Third row: Cards 4 and 3 (left and right)
// Fourth row: Card 9 (center)
// Fifth row: Cards 6 and 5 (left and right)
// Bottom row: Cards 8 and 7 (left and right)
const generateTreeOfLifePositions = (spacing: number = 12): CardPosition[] => {
    const cardHeight = spacing * 1.726; // Maintain card aspect ratio (standard tarot card ratio)
    const verticalGap = spacing * 1.7; // Vertical spacing between rows
    const horizontalUnit = (spacing * 1.8) - spacing / 4; // Base horizontal spacing unit

    return [
        // Card 1 - Intention (top right)
        { left: horizontalUnit * 3.5, top: verticalGap * 1, width: spacing, height: cardHeight },

        // Card 2 - Potential (top left)
        { left: horizontalUnit * 1, top: verticalGap * 1, width: spacing, height: cardHeight },

        // Card 3 - Expression (middle right)
        { left: horizontalUnit * 3.5, top: verticalGap * 2.5, width: spacing, height: cardHeight },

        // Card 4 - Assistance (middle left)
        { left: horizontalUnit * 1, top: verticalGap * 2.5, width: spacing, height: cardHeight },

        // Card 5 - Inner Work (bottom right)
        { left: horizontalUnit * 3.5, top: verticalGap * 4.5, width: spacing, height: cardHeight },

        // Card 6 - Positive Encouragement (bottom left)
        { left: horizontalUnit * 1, top: verticalGap * 4.5, width: spacing, height: cardHeight },

        // Card 7 - Emotional Aspects (bottom center)
        { left: horizontalUnit * 2.25, top: verticalGap * 6.4, width: spacing, height: cardHeight },

        // Card 8 - Thoughts (bottom center left)
        { left: horizontalUnit * 2.25, top: verticalGap * 4.8, width: spacing, height: cardHeight },

        // Card 9 - The Unknown (center middle)
        { left: horizontalUnit * 2.25, top: verticalGap * 3.2, width: spacing, height: cardHeight },

        // Card 10 - Likely Outcome (top center)
        { left: horizontalUnit * 2.25, top: verticalGap * 0.2, width: spacing, height: cardHeight }
    ];
};

interface TreeOfLifeSpreadProps {
    size?: number;
    cardWidth: number;
    displaySpread: boolean;
    getCard: (index: number) => React.ReactNode;
    spacing?: number; // Spacing between cards (default: 12)
}

const TreeOfLifeSpread = ({ size, cardWidth, displaySpread, getCard, spacing = 12 }: TreeOfLifeSpreadProps) => {
    const positions = generateTreeOfLifePositions(spacing);

    return (
        <BaseSpread
            positions={positions}
            size={size}
            cardWidth={cardWidth}
            displaySpread={displaySpread}
            getCard={getCard}
            rotatedCards={[]} // No rotated cards in tree of life spread
            name="tree-of-life"
        />
    );
};

export default TreeOfLifeSpread; 